import React from "react";
import styles from "./CustomRadioGroup.module.css";

const CustomRadioGroup = ({
  label,
  name,
  value,
  onChange,
  options = [],
  required = false,
  disabled = false,
  error,
  inline = true,
  labelClassName = "",
}) => {
  const handleChange = (selectedValue) => {
    if (onChange && !disabled) {
      onChange(selectedValue);
    }
  };

  return (
    <div className={styles.radioGroupContainer}>
      {label && (
        <label
          className={`${styles.label} ${labelClassName} ${
            disabled ? styles.labelDisabled : ""
          }`}
        >
          {label}
          {required && <span className={styles.required}>*</span>}
        </label>
      )}
      <div
        className={`${styles.radioOptions} ${
          inline ? styles.inline : styles.stacked
        }`}
      >
        {options.map((option) => {
          const isDisabled = disabled || option.disabled;
          const isChecked = value === option.value;

          return (
            <label
              key={option.value}
              className={`${styles.radioLabel} ${
                isDisabled ? styles.disabled : ""
              }`}
            >
              <input
                type="radio"
                name={name}
                value={option.value}
                checked={isChecked}
                onChange={() => !isDisabled && handleChange(option.value)}
                disabled={isDisabled}
                className={styles.radioInput}
              />
              <span
                className={`${styles.radioMark} ${isChecked ? styles.checked : ""}`}
              >
                {isChecked && <span className={styles.radioInner}></span>}
              </span>
              <span className={styles.labelText}>{option.label}</span>
            </label>
          );
        })}
      </div>
      {error && <span className={styles.errorText}>{error}</span>}
    </div>
  );
};

export default CustomRadioGroup;